import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homey-bullet-list',
  imports: [],
  templateUrl: './bullet-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BulletListComponent {

}
